import { CurrencyDisplay, CurrencyInputOptions } from "vue-currency-input"

export const DONATION_TYPE_HOSPICE = "Hospice"
export const CURRENCY_OPTIONS: CurrencyInputOptions = {
  currency: "GBP",
  locale: "en-GB",
  currencyDisplay: CurrencyDisplay.symbol,
  valueRange: { min: 0, max: 9999 },
  precision: 2,
  hideCurrencySymbolOnFocus: true,
  hideGroupingSeparatorOnFocus: true,
  hideNegligibleDecimalDigitsOnFocus: true,
  autoDecimalDigits: false,
  useGrouping: true,
  accountingSign: false,
}
